import _ from 'lodash';
import React from 'react';
import DropDown from '../DropDown';
import Switch from 'react-toggle-switch';

function SaleCallChartSettings({widget, setWidgetFieldValue}){
    return (
        <div>
            <div className='displaySettings-row'>
                <span className="label">Diagramdata</span>
                <DropDown
                    setWidgetFieldValue={setWidgetFieldValue}
                    field="displayConfig.labelType"
                    options={[
                        {
                            title: 'Endast samtal',
                            value: 'onlyCalls',
                        },
                        {
                            title: 'Endast varaktighet',
                            value: 'onlyDuration',
                        },
                        {
                            title: 'Samtal och varaktighet',
                            value: 'bothCallAndDuration',
                        }
                    ]}
                    widget={widget}
                />
            </div>
            <div className="displaySettings-row">
                <span className="label">Räkna endast unika telefonnummer per dag</span>
                <div style={{display:"block",marginTop:"5px"}}>
                    <Switch
                        onClick={() => {
                            setWidgetFieldValue(
                                'displayConfig.distinctPhoneNumbers', 
                                !_.get(widget, 'displayConfig.distinctPhoneNumbers', false)
                            );
                            }}
                        on={_.get(widget, 'displayConfig.distinctPhoneNumbers', false)}
                        />
                </div>
            </div>
        </div>
        );
}

SaleCallChartSettings.propTypes = {
    widget: React.PropTypes.object,
    setWidgetFieldValue: React.PropTypes.func,
}

export default SaleCallChartSettings;


/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/DisplaySettings/SaleCallChartSettings.jsx
 **/